import { NgModule } from '@angular/core';
import { AngularFireDatabase } from './database';

@NgModule({
  providers: [ AngularFireDatabase ]
})
export class AngularFireDatabaseModule { }
